<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-page-header
        title="项目备案跟进"
        @back="$router.back()"
        style="padding: 0 0 16px 0"
      />

      <!-- 跟进记录列表 -->
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        :loading="loading"
        row-key="id"
        class="mt-16"
        @change="handleTableChange"
      />

      <!-- 新增跟进 -->
      <div class="toolbar">
        <a-button type="primary" @click="addVisible = true">新增跟进</a-button>
      </div>
    </a-card>

    <!-- 新增跟进弹窗 -->
    <a-modal
      title="新增跟进记录"
      :visible="addVisible"
      :confirm-loading="submitLoading"
      @ok="handleSubmit"
      @cancel="addVisible = false"
    >
      <a-form-model
        ref="formRef"
        :model="form"
        :rules="rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 18 }"
        :colon="false"
      >
        <a-form-model-item label="跟进时间" prop="followTime">
          <a-date-picker
            v-model="form.followTime"
            style="width: 100%"
            value-format="YYYY-MM-DD"
            placeholder="请选择"
          />
        </a-form-model-item>
        <a-form-model-item label="跟进内容" prop="followContent">
          <a-textarea
            v-model="form.followContent"
            :rows="4"
            placeholder="请输入跟进内容"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import request from "@/api/request";

export default {
  data() {
    return {
      id: null,
      loading: false,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`
      },
      columns: [
        {
          title: "跟进时间",
          dataIndex: "followTime",
          width: 120
        },
        {
          title: "跟进人",
          dataIndex: "followUserName",
          width: 100
        },
        {
          title: "跟进内容",
          dataIndex: "followContent",
          ellipsis: true
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          width: 160
        }
      ],
      addVisible: false,
      submitLoading: false,
      form: {
        followTime: null,
        followContent: ""
      },
      rules: {
        followTime: [{ required: true, message: "请选择跟进时间" }],
        followContent: [{ required: true, message: "请输入跟进内容" }]
      }
    };
  },

  mounted() {
    this.id = this.$route.query.id;
    this.loadData();
  },

  methods: {
    loadData() {
      if (!this.id) return;
      this.loading = true;
      request({
        url: "/market-service/scrm/project/filing/follow/list",
        method: "get",
        params: {
          filingId: this.id,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
      })
        .then((res) => {
          this.dataSource = res.list || [];
          this.pagination.total = res.totalSize || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loadData();
    },

    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        request({
          url: "/market-service/scrm/project/filing/follow/add",
          method: "post",
          data: {
            filingId: this.id,
            ...this.form
          }
        })
          .then(() => {
            this.$message.success("跟进记录添加成功");
            this.addVisible = false;
            this.form = { followTime: null, followContent: "" };
            this.loadData();
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 16px;
}

.toolbar {
  margin-top: 12px;
}

.mt-16 {
  margin-top: 16px;
}
</style>
